// dependencies
import React from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import { faArrowLeft } from "@fortawesome/pro-solid-svg-icons";

import Button from "../../components/Button";
// components
import FeedbackViewer from "../../components/Feedback/View";
import PageTitle from "../../components/PageTitle";

// selectors
import { getAppHeight } from "../../selectors/app";
import { getURLParam } from "../../selectors/navigation";

const PageFeedback = () => {
	const navigate = useNavigate();
	const windowHeight = useSelector(getAppHeight);
	const feedbackId = useSelector((state) => getURLParam(state, "feedbackId"));

	const handleDelete = () => {
		navigate("/company/feedback/");
	};

	const handleBack = () => {
		navigate("/company/feedback/");
	};

	return (
		<>
			<PageTitle title="Feedback - PerformYard" />
			<section className="react-page page-view-feedback" style={{ height: windowHeight, overflow: "auto" }}>
				<div className="controls-container">
					<Button onClick={handleBack} isHollow={true} icon={faArrowLeft}>
						Back
					</Button>
				</div>

				<section className="feedback-container">
					<section className="wrapper">
						<FeedbackViewer onDelete={handleDelete} feedbackId={feedbackId} />
					</section>
				</section>
			</section>
		</>
	);
};

export default PageFeedback;
